import { render, staticRenderFns } from "./CreateDepartment.vue?vue&type=template&id=210c8e24&scoped=true&"
import script from "./CreateDepartment.vue?vue&type=script&lang=js&"
export * from "./CreateDepartment.vue?vue&type=script&lang=js&"
import style0 from "./CreateDepartment.vue?vue&type=style&index=0&id=210c8e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c8e24",
  null
  
)

export default component.exports